<template>
  <div class="col-4">
    <transition-expand-side :expand-direction="'expand-side-left'">
      <b-card no-body class="overflow-hidden border basket sticky-basket">
        <b-card-header>
          <b-col class="col-12 px-0 d-flex align-items-center">
            <b-button class="close position-absolute" variant="link" @click="close">
              <font-awesome-icon icon="times" />
            </b-button>
            <h2 class="text-center m-auto h4">
              {{ single ? $t('Lead Details') : $t('Bulk Buy') }}
            </h2>
          </b-col>
        </b-card-header>
        <b-card-body class="card-body p-4 p-lg-3 p-xl-4 overflow-hidden rounded-bottom">
          <div v-if="checking">
            <spinner>{{ $t('Checking availability') }}</spinner>
          </div>
          <div v-else-if="!checking && !available">
            <b-alert :show="true" variant="danger" v-html="notAvailableReason.message" />
            <not-available @close="closeNotAvailable" />
          </div>
          <div v-else>
            <b-col v-if="single">
              <div v-if="notAvailableReason">
                <b-alert v-if="notAvailableReason.email" :show="true" variant="warning">
                  <span v-if="validationSuccess">
                    {{ $t('Email sent, please check your inbox') }}
                  </span>
                  <span v-else>
                    {{ 
                      $t(
                        'Before you can buy leads, we need to verify your email address. Please check your Inbox at "{emailAddress}" and click the verification link.',
                        { emailAddress: company.company_user.email }
                      )
                    }}
                    <a class="text-link text-link-reset cursor-pointer" @click.prevent.stop="onSendToken">{{ $t('Resend verification link') }}</a>
                  </span>
                  <span v-if="timeLeftTillCanSendValidation !== null">
                    {{ $t('You must wait {timeLeftTillCanSendValidation} before resending the validation email', { timeLeftTillCanSendValidation }) }}
                  </span>
                </b-alert>
                <b-alert v-else :show="true" variant="warning" v-html="notAvailableReason.message" />
              </div>
              <buy-lead
                :lead="leads[0]"
                :single="single"
                :block="hasError"
                variant="link"
                @close="close"
              />
            </b-col>

            <b-col v-else>
              <bulk-buy @cancel="close" @remove="removeLead" @purchased="$emit('purchased')" />
            </b-col>
          </div>
        </b-card-body>
      </b-card>
    </transition-expand-side>
  </div>
</template>

<script>
import TransitionExpandSide from "@/components/animation/TransitionExpandSide";
import BuyLead from "@/components/pane/BuyLead";
import BulkBuy from "@/components/pane/BulkBuy";
import {BULK_BUY, CLEAR_SELECTED_LEADS, SELECTED_LEADS} from "@/store/leads/mutation-types";
import Spinner from "@/components/animation/Spinner";
import NotAvailable from "@/components/pane/NotAvailable";
import leadErrors from "@/imports/mixins/leadErrors";
import emailValidation from "@/imports/mixins/emailValidation";

export default {
  name: "LeadBasket",
  components: {NotAvailable, Spinner, BulkBuy, BuyLead, TransitionExpandSide},
  mixins: [leadErrors, emailValidation],
  computed: {
    single: function () {
      return this.leads.length === 1 && !this.$store.state.leads.BULK_BUY;
    },
    leads: {
      get: function () {
        return this.$store.state.leads.SELECTED_LEADS;
      },
      set: function (value) {
        this.$store.commit(SELECTED_LEADS, value);
      }
    },
    company: function() {
      return this.$store.state.company.COMPANY;
    },
    checking: function () {
      return this.$store.state.leads.AVAILABILITY_CHECK;
    },
  },
  methods: {
    close: function () {
      this.$store.commit(CLEAR_SELECTED_LEADS);
      this.$store.commit(BULK_BUY, false);
      this.notAvailableReason = null;
      this.$emit('refresh');
    },
    closeNotAvailable: function () {
      if (this.single) {
        this.close();
      }
    },
    removeLead: function(lead) {
      this.leads = [... this.leads.filter(selectedLead => selectedLead[0].id !== lead[0].id)];
    }
  }
}
</script>

<style scoped lang="scss">
.basket {
  .card {
    &-body {
      font-size: $font-size-14;
    }
  }
}

@media only screen and (min-width: 1400px) and (max-width: 1550px) {
  .basket .card-body {
    padding: 1rem !important;
  }
}

.sticky-basket {
  top: 90px;
  position: sticky;
}

</style>
